import MessageAlert from 'app/components/MessageAlert'
import effects from 'app/effects/effects'
import { errorTypes } from 'commons/error'
import { Routes } from 'app/services/routeService/routeService'
import { getRegisterSuccessPermissionState } from 'app/main/registerSuccess/RegisterSuccess.js'
import * as R from 'ramda'
export const CHECK_EMAIL = 'CHECK_EMAIL'
export const CHECK_EMAIL_PROCEED_WITH_CAUTION =
  'CHECK_EMAIL_PROCEED_WITH_CAUTION'
export const CHECK_EMAIL_ERROR = 'CHECK_EMAIL_ERROR'
export const REGISTER = 'REGISTER'
export const REGISTER_ERROR = 'REGISTER_ERROR'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const CHECK_PLACE = 'CHECK_PLACE'
export const CHECK_PLACE_PROCEED_WITH_CAUTION =
  'CHECK_PLACE_PROCEED_WITH_CAUTION'
export const CHECK_PLACE_ERROR = 'CHECK_PLACE_ERROR'

export function submitRegister(model, formatMessage, errorMiddleware, history) {
  return (dispatch) => {
    dispatch({ type: REGISTER })
    effects.apis
      .register(model)
      .then(() => {
        dispatch({ type: REGISTER_SUCCESS })
        history.push(
          Routes.registerSuccess(),
          getRegisterSuccessPermissionState(),
        )
      })
      .catch((error) => {
        dispatch({ type: REGISTER_ERROR, payload: error })
        const onNext = () => {
          dispatch(
            MessageAlert.showNetworkError(formatMessage)(
              error,
              errorTypes.register,
            ),
          )
        }
        errorMiddleware(onNext, error)
      })
  }
}

export function submitCuratedRegister(
  model,
  formatMessage,
  errorMiddleware,
  history,
) {
  return (dispatch) => {
    dispatch({ type: REGISTER })
    effects.apis
      .postCuratedPlaceSingUp(model)
      .then(() => {
        dispatch({ type: REGISTER_SUCCESS })
        history.push(
          Routes.registerSuccess(),
          getRegisterSuccessPermissionState(),
        )
      })
      .catch((error) => {
        dispatch({ type: REGISTER_ERROR, payload: error })
        const onNext = () => {
          dispatch(
            MessageAlert.showNetworkError(formatMessage)(
              error,
              errorTypes.register,
            ),
          )
        }
        errorMiddleware(onNext, error)
      })
  }
}

export function checkEmail(
  { email, onSuccess, onProceedWithCaution },
  formatMessage,
  errorMiddleware,
) {
  return (dispatch) => {
    dispatch({ type: CHECK_EMAIL })
    return effects.apis
      .checkEmail({ email })
      .then(() => {
        onSuccess()
      })
      .catch((error) => {
        switch (error.response.data.details.code) {
          case 604:
            dispatch({ type: CHECK_EMAIL_PROCEED_WITH_CAUTION })
            onProceedWithCaution()
            break
          default: {
            dispatch({ type: CHECK_EMAIL_ERROR })
            const onNext = () => {
              dispatch(
                MessageAlert.showNetworkError(formatMessage)(
                  error,
                  errorTypes.register,
                ),
              )
            }
            errorMiddleware(onNext, error)
          }
        }
      })
  }
}

export function checkPlace(
  { googlePlaceId, onSuccess, onProceedWithCaution },
  formatMessage,
  errorMiddleware,
) {
  return (dispatch) => {
    dispatch({ type: CHECK_PLACE })

    if (R.isNil(googlePlaceId)) {
      dispatch({ type: CHECK_PLACE_PROCEED_WITH_CAUTION })
      onProceedWithCaution()
      return
    }

    return effects.apis
      .getCuratedCheck(googlePlaceId)
      .then(({ name }) => {
        dispatch({ type: CHECK_PLACE_PROCEED_WITH_CAUTION })
        onSuccess(name)
      })
      .catch((error) => {
        error.response.data.details.code = 604
        switch (error.response.data.details.code) {
          case 604:
            dispatch({ type: CHECK_PLACE_PROCEED_WITH_CAUTION })
            onProceedWithCaution()
            break
          default: {
            dispatch({ type: CHECK_PLACE_ERROR })
            const onNext = () => {
              dispatch(
                MessageAlert.showNetworkError(formatMessage)(
                  error,
                  errorTypes.register,
                ),
              )
            }
            errorMiddleware(onNext, error)
          }
        }
      })
  }
}
